import { jsx as a, jsxs as w } from "react/jsx-runtime";
import { useMemo as z } from "react";
import { useTheme as I, Stack as S } from "@mui/material";
import { D } from "./DropdownMenu-5LqeuLY1.js";
import { v as M, a as N } from "./Slider-vVmtecg6.js";
import { T as j } from "./Typography-HkIo7ajX.js";
import { s as u } from "./spacings-C27fg6SF.js";
const B = ({ languageCode: e, size: r }) => /* @__PURE__ */ a(
  M,
  {
    locale: e.slice(-2) || "",
    size: r
  }
), C = (e) => e.sort((r, o) => r.isPrimary && !o.isPrimary ? -1 : !r.isPrimary && o.isPrimary || r.language.langName > o.language.langName ? 1 : -1), A = ({
  onOpen: e = () => {
  },
  onClose: r = () => {
  },
  zIndex: o = void 0,
  onMenuItemSelect: g,
  isDisabled: f = !1,
  shouldShowPrimaryBadge: d = !0,
  children: l,
  shouldDisablePortal: p = !1,
  shouldCloseOnSelect: y = !1,
  placement: T = "bottom",
  translations: m,
  selectedTranslationId: h = "",
  dropdownMaxHeight: v = "30vh",
  hasOptionCheckIcon: c = !1
}) => {
  const x = I(), i = z(() => C(m), [m]);
  return i.length <= 1 || !l ? null : /* @__PURE__ */ a(
    D,
    {
      onOpen: e,
      placement: T,
      isDisabled: f,
      onClose: r,
      shouldDisablePortal: p,
      shouldCloseOnSelect: y,
      dropdownMaxHeight: v,
      hasOptionCheckIcon: c,
      menuListZindex: o ?? x.zIndex.modal + 1,
      options: i.map(({ language: n, isPrimary: s, id: t }) => {
        const P = s && d && !c;
        return {
          label: /* @__PURE__ */ w(
            S,
            {
              direction: "row",
              spacing: u.lg,
              ml: u.sm,
              children: [
                /* @__PURE__ */ a(
                  j,
                  {
                    variant: "text",
                    size: "sm",
                    fontWeight: "medium",
                    color: "grey.700",
                    children: n.langName
                  }
                ),
                !!P && /* @__PURE__ */ a(
                  N,
                  {
                    variant: "filled",
                    color: "success",
                    label: "Primary",
                    size: "small"
                  }
                )
              ]
            }
          ),
          value: t,
          isSelected: h === t,
          IconComponent: /* @__PURE__ */ a(
            B,
            {
              languageCode: n.langCode,
              size: 20
            }
          )
        };
      }),
      onMenuItemSelect: ({ value: n }) => {
        const s = i.find(({ id: t }) => t === n);
        s && g(s);
      },
      children: l
    }
  );
};
export {
  A as T
};
